import { render, staticRenderFns } from "./UiButtonIcon.vue?vue&type=template&id=74f1793d&"
import script from "./UiButtonIcon.vue?vue&type=script&lang=js&"
export * from "./UiButtonIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports